import { render, staticRenderFns } from "./SecurityControls.vue?vue&type=template&id=faf35f0a&"
import script from "./SecurityControls.vue?vue&type=script&lang=js&"
export * from "./SecurityControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports